import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import CentroNotificacionesGrid from './CentroNotificacionesGrid.jsx'

class CentroNotificaciones extends Component {
	render() {
		return (
			<div className="content-wrapper">
				<div className="content-header row">
					<div className="content-header-left col-md-6 col-12 mb-2">
						<h3 className="content-header-title">
							<FormattedMessage id="centroNotificaciones.titulo" defaultMessage="Centro de Notificaciones" />
						</h3>
					</div>
				</div>
				<div className="content-body">
					<CentroNotificacionesGrid />
				</div>
			</div>
		);
	}
}

export default CentroNotificaciones
